  <div class="verif-block custom-display" *ngIf="!isHidden && current_user && !current_user.email_verified_at">
    <p class="text text-medium">{{'PLEASE VALIDATE YOUR EMAIL ADDRESS BY CLICKING THE LINK RECEIVED BY EMAIL'|translate}}</p>
    <!-- <p class="text text-regular">If you have not received the email, please check your spam or click <a class="link" (click)="verifyEmail()" style="cursor:pointer">
      here</a> to resend
      the activation email </p> -->
      <button (click)="verifyEmail()" class="btn btn-apply">{{'resend email'|translate}}</button>
  </div>
